<template>
  <v-container fluid style="background-color: #f5f5f5; color: #333333; padding: 20px;">
    <h1 class="text-center mb-5 primary--text">Panel de Análisis Delictual</h1>
    
    <!-- Filtros de fecha -->
    <v-card class="mb-6" elevation="3">
      <v-card-text>
        <v-row>
          <v-col cols="12" md="4">
            <h3 class="primary--text">Total por causa</h3>
          </v-col>
          <v-col cols="12" md="4" class="d-flex align-center">
            <v-text-field
              label="Fecha Inicial"
              type="date"
              v-model="fechaInicial"
              outlined
              dense
              class="mr-2"
              color="primary"
            ></v-text-field>
            <v-text-field
              label="Fecha Final"
              type="date"
              v-model="fechaFinal"
              outlined
              dense
              color="primary"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="text-center">
            <v-card class="pa-2" outlined color="primary" dark>
              <h2 class="display-1 font-weight-bold">{{ totalCasos }}</h2>
              <p>Total de Casos</p>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    
    <!-- Filtros adicionales -->
    <v-card class="mb-6" elevation="3">
      <v-card-text>
        <v-row>
          <v-col cols="12" md="3">
            <h3 class="subtitle-1 font-weight-bold mb-2">Departamento</h3>
            <v-select
              :items="departamentos"
              label="Todas"
              outlined
              dense
              color="primary"
            ></v-select>
          </v-col>
          <v-col cols="12" md="3">
            <h3 class="subtitle-1 font-weight-bold mb-2">Causa</h3>
            <v-select
              :items="causas"
              label="Todas"
              outlined
              dense
              color="primary"
            ></v-select>
          </v-col>
          <v-col cols="12" md="3">
            <h3 class="subtitle-1 font-weight-bold mb-2">Departamental</h3>
            <v-select
              :items="departamentales"
              label="Todas"
              outlined
              dense
              color="primary"
            ></v-select>
          </v-col>
          <v-col cols="12" md="3">
            <h3 class="subtitle-1 font-weight-bold mb-2">Dependencia</h3>
            <v-select
              :items="dependencias"
              label="Todas"
              outlined
              dense
              color="primary"
            ></v-select>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    
    <!-- Gráficos principales -->
    <v-row>
      <v-col cols="12" md="6">
        <v-card class="pa-3 mb-6" elevation="3">
          <v-card-title class="primary--text">Total por Causa</v-card-title>
          <v-card-text>
            <apexchart type="pie" :options="pieOptions" :series="pieSeries"></apexchart>
          </v-card-text>
        </v-card>
        <v-card class="pa-3" elevation="3">
          <v-card-title class="primary--text">Total por Operandi</v-card-title>
          <v-card-text>
            <apexchart type="bar" :options="barOptions" :series="barSeries"></apexchart>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card class="pa-3 mb-6" elevation="3">
          <v-card-title class="primary--text">Recuento de Causa por Departamental</v-card-title>
          <v-card-text>
            <apexchart type="bar" :options="deptBarOptions" :series="deptBarSeries"></apexchart>
          </v-card-text>
        </v-card>
        <v-card class="pa-3" elevation="3">
          <v-card-title class="primary--text">Mapa Delictual - San Juan</v-card-title>
          <v-card-text>
            <div id="map" style="height: 350px;"></div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    
    <!-- Gráfico por mes -->
    <v-row class="mt-6">
      <v-col cols="12">
        <v-card class="pa-3" elevation="3">
          <v-card-title class="primary--text">Total por Mes</v-card-title>
          <v-card-text style="height: 400px;">
            <apexchart type="line" height="350" :options="lineOptions" :series="lineSeries"></apexchart>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet.heat';

export default {
  name: 'GraficosView',
  components: {
    apexchart: VueApexCharts
  },
  data() {
    return {
      fechaInicial: '2021-01-01',
      fechaFinal: '2021-12-31',
      totalCasos: 548,
      departamentos: ['Todas', 'Departamento 01', 'Departamento 02', 'Departamento 03'],
      causas: ['Todas', 'Hurto', 'Robo', 'Estafa', 'Amenazas', 'Daño'],
      departamentales: ['Todas', 'Departamental 01', 'Departamental 02', 'Departamental 03'],
      dependencias: ['Todas', 'Dependencia 01', 'Dependencia 02', 'Dependencia 03'],
      pieSeries: [31, 25, 11, 6, 3, 3, 2, 2, 1, 1],
      pieOptions: {
        chart: {
          type: 'pie',
          foreColor: '#333333'
        },
        labels: ['Hurto', 'Robo', 'Estafa', 'Amenazas', 'Daño', 'Lesiones', 'Tentativa de Robo', 'Lesiones Art N° 89', 'Lesiones Art N° 94', 'Otros'],
        colors: ['#1976D2', '#2196F3', '#64B5F6', '#90CAF9', '#42A5F5', '#1E88E5', '#0D47A1', '#5C6BC0', '#3949AB', '#303F9F'],
        legend: {
          position: 'right'
        },
        responsive: [{
          breakpoint: 600,
          options: {
            legend: {
              position: 'bottom'
            }
          }
        }]
      },
      barSeries: [{
        name: 'Operandi',
        data: [200, 180, 150, 120, 100, 80, 60, 40]
      }],
      barOptions: {
        chart: {
          type: 'bar',
          foreColor: '#333333'
        },
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              position: 'top',
            },
          }
        },
        colors: ['#2196F3'],
        dataLabels: {
          enabled: true,
          offsetX: -6,
          style: {
            fontSize: '12px',
            colors: ['#333333']
          }
        },
        xaxis: {
          categories: ['Sin Violencia', 'Con Violencia', 'Otros', 'Arrebato', 'Cuento del Tío', 'Oportunismo', 'Lesiones', 'Amenazas']
        }
      },
      deptBarSeries: [{
        name: 'Casos',
        data: [120, 110, 100, 95, 90, 85, 80, 75]
      }],
      deptBarOptions: {
        chart: {
          type: 'bar',
          foreColor: '#333333'
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded'
          },
        },
        colors: ['#1976D2'],
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: ['Departamental 05', 'Departamental 06', 'Departamental 02', 'Departamental 03', 'Dirección D.S.', 'Departamental 01', 'Departamental 04', 'Departamental 07'],
        },
        yaxis: {
          title: {
            text: 'Número de casos'
          }
        }
      },
      lineSeries: [{
        name: 'Casos por Mes',
        data: [400, 450, 500, 550, 600, 650, 700]
      }],
      lineOptions: {
        chart: {
          type: 'line',
          foreColor: '#333333',
          height: 350
        },
        stroke: {
          curve: 'smooth',
          width: 3
        },
        colors: ['#1976D2'],
        markers: {
          size: 6
        },
        xaxis: {
          categories: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio']
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'],
            opacity: 0.5
          }
        }
      }
    }
  },
  mounted() {
    this.initMap();
  },
  methods: {
    initMap() {
      setTimeout(() => {
        // Coordenadas de San Juan, Argentina
        const sanJuanCoords = [-31.5375, -68.5364];
        const map = L.map('map').setView(sanJuanCoords, 13);
        
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          maxZoom: 19,
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(map);
        
        // Generar puntos aleatorios alrededor de San Juan para el mapa de calor
        const heatPoints = [];
        const locations = [];
        
        // Zonas de San Juan con mayor densidad de puntos
        const zones = [
          { center: [-31.5375, -68.5364], name: 'Centro', points: 25, intensity: 1.0 }, // Centro de San Juan
          { center: [-31.5280, -68.5420], name: 'Capital Norte', points: 18, intensity: 0.8 },
          { center: [-31.5480, -68.5280], name: 'Capital Este', points: 15, intensity: 0.7 },
          { center: [-31.5320, -68.5520], name: 'Capital Oeste', points: 12, intensity: 0.6 },
          { center: [-31.5580, -68.5350], name: 'Capital Sur', points: 10, intensity: 0.5 },
          { center: [-31.5150, -68.5250], name: 'Chimbas', points: 8, intensity: 0.4 },
          { center: [-31.5650, -68.5150], name: 'Rawson', points: 7, intensity: 0.4 },
          { center: [-31.5200, -68.5650], name: 'Rivadavia', points: 6, intensity: 0.3 }
        ];
        
        // Generar puntos para cada zona
        zones.forEach(zone => {
          for (let i = 0; i < zone.points; i++) {
            // Generar punto aleatorio dentro de un radio de ~500m de cada zona
            const lat = zone.center[0] + (Math.random() - 0.5) * 0.01;
            const lng = zone.center[1] + (Math.random() - 0.5) * 0.01;
            
            // Añadir al array de puntos de calor con su intensidad
            heatPoints.push([lat, lng, zone.intensity]);
            
            // Guardar ubicación para marcadores
            locations.push([lat, lng]);
          }
        });
        
        // Añadir marcadores para cada punto
        locations.forEach(loc => {
          L.circleMarker(loc, {
            radius: 5,
            fillColor: "#1976D2",
            color: "#fff",
            weight: 1,
            opacity: 0.7,
            fillOpacity: 0.6
          }).addTo(map);
        });
        
        // Añadir capa de mapa de calor
        L.heatLayer(heatPoints, {
          radius: 25, 
          blur: 15,
          maxZoom: 17,
          gradient: {0.4: '#3388ff', 0.65: '#ffff00', 1: '#ff0000'}
        }).addTo(map);
        
        // Añadir etiquetas para las zonas principales
        zones.forEach(zone => {
          L.marker(zone.center, {
            icon: L.divIcon({
              className: 'zone-label',
              html: `<div class="zone-name">${zone.name}</div>`,
              iconSize: [100, 20],
              iconAnchor: [50, 10]
            })
          }).addTo(map);
        });
      }, 500);
    }
  }
}
</script>

<style scoped>
#map {
  height: 350px;
  z-index: 0;
  border-radius: 4px;
}

.zone-name {
  background-color: rgba(255, 255, 255, 0.7);
  padding: 2px 5px;
  border-radius: 3px;
  font-size: 10px;
  font-weight: bold;
  color: #333;
  text-align: center;
  white-space: nowrap;
}
</style>
